/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Instant_GatewayInputs */

const en_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Gateway`)
};

const es_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puerta de enlace instantánea`)
};

const fr_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passerelle instantanée`)
};

const de_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Gateway`)
};

const ja_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インスタントゲートウェイ`)
};

const zh_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即时网关入口`)
};

const ar_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة فورية`)
};

const id_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerbang Instan`)
};

const it_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway Istantaneo`)
};

const ru_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мгновенный шлюз`)
};

const pt_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway Instantâneo`)
};

const ko_instant_gateway = /** @type {(inputs: Instant_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인스턴트 게이트웨이`)
};

/**
* | output |
* | --- |
* | "Instant Gateway" |
*
* @param {Instant_GatewayInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const instant_gateway = /** @type {((inputs?: Instant_GatewayInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Instant_GatewayInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_instant_gateway(inputs)
	if (locale === "es") return es_instant_gateway(inputs)
	if (locale === "fr") return fr_instant_gateway(inputs)
	if (locale === "de") return de_instant_gateway(inputs)
	if (locale === "ja") return ja_instant_gateway(inputs)
	if (locale === "zh") return zh_instant_gateway(inputs)
	if (locale === "ar") return ar_instant_gateway(inputs)
	if (locale === "id") return id_instant_gateway(inputs)
	if (locale === "it") return it_instant_gateway(inputs)
	if (locale === "ru") return ru_instant_gateway(inputs)
	if (locale === "pt") return pt_instant_gateway(inputs)
	return ko_instant_gateway(inputs)
});